































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class LeafRow extends Vue {

    @Prop() row!: any;  
    @Prop() propKey!: string;
    @Prop() startingPeriod: boolean;
    @Prop() formOptions: any;

    /** input event */
    showInput(e) {
        this.$emit("input", true);
    }

}
